const {
  BUSINESS_DESCRIPTION,
  BUSINESS_EMAIL,
  BUSINESS_PHONE,
} = require('./business')

const locations = [
  {
    id: 'glendale',
    name: 'Glendale Studio',
    address: '74-12 88th Street, Glendale, NY 11385',
    mapTitle: 'Google Map of PrintAWorld Glendale Studio',
    mapUrl:
      'https://maps.google.com/maps?q=74-12%2088th%20Street,%20Glendale,%20NY%2011385&t=&z=13&ie=UTF8&iwloc=&output=embed',
  },
  {
    id: 'brooklyn',
    name: 'Brooklyn Studio',
    address: '616 Berriman Street, Brooklyn, NY 11208',
    mapTitle: 'Google Map of PrintAWorld Brooklyn Studio',
    mapUrl:
      'https://maps.google.com/maps?q=616%20Berriman%20Street,%20Brooklyn,%20NY%2011208&t=&z=13&ie=UTF8&iwloc=&output=embed',
  },
]

const brooklynAddressPattern = /\d{1,5}(?:-\d{1,5})?\s+[^,"\\]*(?:Avenue|Ave\.?|Street|St\.?|Boulevard|Blvd\.?)\s*[^,"\\]*,\s*Brooklyn,\s*(?:NY|NYC)(?:\s+\d{5})?/gi

const replaceBrooklynAddress = value =>
  value.replace(brooklynAddressPattern, locations[1].address)

const toPostalAddress = location => {
  const [
    streetAddress,
    addressLocality,
    addressRegionAndPostalCode,
  ] = location.address.split(', ')
  const [addressRegion, postalCode] = addressRegionAndPostalCode.split(' ')

  return {
    '@type': 'PostalAddress',
    streetAddress,
    addressLocality,
    addressRegion,
    postalCode,
    addressCountry: 'US',
  }
}

const normalizeLocationSchema = value => {
  const schema = JSON.parse(value)
  const locationTypes = new Set([
    'LocalBusiness',
    'Organization',
    'ProfessionalService',
  ])

  if (!locationTypes.has(schema['@type'])) {
    return value
  }

  schema.address = locations.map(toPostalAddress)
  delete schema.geo
  delete schema.hasMap
  // What agents check before recommending or contacting a business.
  if (!schema.description) schema.description = BUSINESS_DESCRIPTION
  schema.email = BUSINESS_EMAIL
  schema.telephone = schema.telephone || BUSINESS_PHONE
  schema.contactPoint = {
    '@type': 'ContactPoint',
    contactType: 'sales',
    email: BUSINESS_EMAIL,
    telephone: BUSINESS_PHONE,
    areaServed: 'US',
    availableLanguage: 'en',
  }

  return JSON.stringify(schema)
}

module.exports = {
  locations,
  normalizeLocationSchema,
  replaceBrooklynAddress,
}
